import { render, staticRenderFns } from "./PrivateNotes.vue?vue&type=template&id=983b703a&scoped=true"
import script from "./PrivateNotes.vue?vue&type=script&lang=js"
export * from "./PrivateNotes.vue?vue&type=script&lang=js"
import style0 from "./PrivateNotes.vue?vue&type=style&index=0&id=983b703a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983b703a",
  null
  
)

export default component.exports